import NextImage from "next/image";
import React from "react";
import ThumbnailCaptureBackgroundImage from "@public/assets/images/capture/Background.webp";
import useVaultStore from "@/stores/zustand/vault/useVaultStore";

// const CENTER_TOP = ((943 / 1280) * 100).toFixed(3);
export const CENTER_TOP = 73.671875;

export const ThumbnailCaptureBackground = () => {
  const currentPage = useVaultStore((state) => state.currentPage);

  return (
    <div
      className={
        "pointer-events-none absolute inset-0 bg-[var(--white)] rounded-[20px] overflow-hidden z-0"
      }
    >
      <NextImage
        src={ThumbnailCaptureBackgroundImage}
        width={0}
        height={0}
        sizes={"100vw"}
        alt={`${currentPage} background image`}
        loading={"eager"}
        priority={true}
        className="absolute inset-0 z-0"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};
